import { render, staticRenderFns } from "./order-attendance-warning.vue?vue&type=template&id=0d518f5f"
import script from "./order-attendance-warning.vue?vue&type=script&lang=js"
export * from "./order-attendance-warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports